import styled from '@emotion/styled';

export default styled.span({
    [':hover']: {
        cursor: 'pointer'
    }
});
